module.exports = __webpack_public_path__ + "resources/img/img_dataflow_m.0f14785ca5e9c47721c84bb8545852fc.png";